import { render, staticRenderFns } from "./msCellInputV2.vue?vue&type=template&id=2142fbe0&scoped=true"
import script from "./msCellInputV2.vue?vue&type=script&lang=js"
export * from "./msCellInputV2.vue?vue&type=script&lang=js"
import style0 from "./msCellInputV2.vue?vue&type=style&index=0&id=2142fbe0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2142fbe0",
  null
  
)

export default component.exports